const apiUrl = process.env.REACT_APP_API_URL;

/** Descarrega el PDF d'una proposta. Retorna un object URL del blob. */
export const GetPropostaPdf = async (id: number, page: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/propostes/${id}/pdf`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.error('Error al descarregar el PDF de la proposta', error);
        return "";
    }
};
